import { useNavigate } from "react-router-dom"

interface ActionButtonsProps {
    onProcess: () => void
    onClear: () => void
    isProcessing: boolean
    hasInput: boolean
}

export const ActionButtons = ({
    onProcess,
    onClear,
    isProcessing,
    hasInput
}: ActionButtonsProps) => {
    const navigate = useNavigate()

    return (
        <div className="mt-8 space-y-3">
            <button
                onClick={onProcess}
                disabled={isProcessing || !hasInput}
                className="w-full h-12 font-bold text-white rounded-lg bg-secondary-1 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-secondary-2 transition-colors"
            >
                {isProcessing ? "Processando..." : "Processar Lote"}
            </button>

            <button
                onClick={onClear}
                disabled={isProcessing}
                className="w-full h-12 font-bold text-gray-700 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
            >
                Limpar
            </button>

            <button
                onClick={() => navigate("/rastreamento")}
                className="w-full h-12 font-bold text-white bg-gray-600 rounded-lg hover:bg-gray-700 transition-colors"
            >
                Voltar ao Rastreamento
            </button>
        </div>
    )
}
